import { useContainerRef } from '@autone/utils';

import { Badge } from '../atoms/Badge';
import { Tooltip } from '../atoms/Tooltip';
import { RenderWithOverflow } from '../renderers';
import { cn } from '../utils';

interface BadgeListWithOverflowProps {
  items: string[];
  maxVisible?: number;
  className?: string;
}

export const BadgeListWithOverflow = ({
  items,
  maxVisible = 2,
  className,
}: BadgeListWithOverflowProps) => {
  const containerRef = useContainerRef<HTMLDivElement>(null);

  if (items.length === 0) return null;

  return (
    <div
      className={cn('flex gap-1 items-center flex-wrap', className)}
      ref={containerRef}
    >
      <RenderWithOverflow
        items={items}
        maxVisible={maxVisible}
        renderItem={(item) => (
          <Badge key={item} variant="secondary">
            {item}
          </Badge>
        )}
        renderOverflow={(overflowItems) => (
          <Tooltip
            side="bottom"
            align="end"
            content={overflowItems.join(', ')}
            className="max-w-56"
            container={containerRef.current}
          >
            <Badge variant="secondary" className="cursor-default">
              +{overflowItems.length}
            </Badge>
          </Tooltip>
        )}
      />
    </div>
  );
};
